/**
 * UX Breakpoints defined in Figma, Chakra work with a "mobile first" min-width media query.
 * The values here are one px more in order to understand min-width easier.
 *
 * For example, if the following responsive requirement for a css property:
 * - mobile the background-color is 'green' (the "base" 0px -> 375px)
 * - tablet the background-color is 'blue' (375px -> 768px)
 * - desktop the background-color is 'red' (768px -> any widescreen eg 1600px)
 *
 * You can use the Chakra breakpoint tokens like this:
 *
<Flex
    sx={{
        w: 20,
        h: 20,
        bg: {
            mobile: 'green',
            tablet: 'blue',
            desktop: 'red'
        },
        // Custom queries can still be done like this:
        '@media screen and (max-width: custom thing px)': {
            bg: 'orange'
        }
    }}
 />
 *
 * @see docs https://chakra-ui.com/docs/styled-system/features/responsive-styles
 */
export const breakpoints = {
  mobile: '0px',
  tablet: '376px',
  medium: '450px',
  large: '500px',
  desktop: '769px'
}
